import { IntegrationTypeResponse, IntegrationDataResponse } from '@/ts/HococoInterfaces';

import IntegrationData from '@/ts/IntegrationData';

export default class Integration {
    public static FromResponse(response: IntegrationTypeResponse) {
        return new Integration(
            response.id,
            response.key,
            response.name,
            response.created_at,
            response.updated_at,
            response.deleted_at,
        );
    }

    public id: number;
    public key: string;
    public name: string;
    public createdAt: string;
    public updatedAt: string;
    public deletedAt?: string;

    public integrationData: IntegrationData[] = [];
    public integrationDataMap: { [index: number]: number } = {};

    constructor(
        id: number,
        key: string,
        name: string,
        createdAt: string,
        updatedAt: string,
        deletedAt?: string,
    ) {
        this.id = id;
        this.key = key;
        this.name = name;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.deletedAt = deletedAt;
    }

    public updateData(response: IntegrationTypeResponse) {
        this.id        = response.id;
        this.key       = response.key;
        this.name      = response.name;
        this.createdAt = response.created_at;
        this.updatedAt = response.updated_at;
        this.deletedAt = response.deleted_at;
    }

    public synchronizeData(data: IntegrationDataResponse[]) {
        for (const entry of data) {
            if (this.integrationDataMap.hasOwnProperty(entry.id)) {
                this.integrationData[this.integrationDataMap[entry.id]].updateData(entry);
                continue;
            }

            this.integrationDataMap[entry.id] = this.integrationData.push(IntegrationData.FromResponse(entry)) - 1;
        }
    }
}

